import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import LogRocket from 'logrocket';

import App from './App';
// @ts-ignore
import reportWebVitals from './reportWebVitals';
import store from './store';
import { RoleProvider } from './hooks/useRole';

import { Auth0ProviderWithNavigate } from './auth0-provider-with-navigate';

// ----------------------------------------------------------------------

if (process.env.REACT_APP_PES_ENV === 'PROD') {
	LogRocket.init('ioezva/pes', {
		dom: {
			isEnabled: false,
		},
	});
}

const rootElement = document.getElementById('root');
if (!rootElement) {
	throw new Error("Root element not found. Please ensure the element with id 'root' exists.");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
	<BrowserRouter>
		<Auth0ProviderWithNavigate>
			<RoleProvider>
				<Provider store={store}>
					<App />
				</Provider>
			</RoleProvider>
		</Auth0ProviderWithNavigate>
	</BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
